export enum BenchmarkGranularity {
    WEEKLY = "Weekly",
    MONTHLY = "Monthly",
}
